import { useTranslation } from 'react-i18next';
import { sortByProperty } from '@web/utils/src';
import { InvoiceStatuses } from '@web/utils/src/components/InvoiceStatus/InvoiceStatus';
import { Invoice, Sort } from '@/types';
import { useDocuments } from '../DocumentsLayout';
import InvoicesTable from './components/InvoicesTable';

type PInvoice = Pick<
  Invoice,
  'id' | 'paymentOptions' | 'totalGross' | 'issuedAt'
> & {
  status: InvoiceStatuses;
};
const InvoicesPage: React.FC = () => {
  const data = useDocuments();
  const { t } = useTranslation();

  // sortByProperty needs to be made generic
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const invoices = sortByProperty(
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (data?.currentUser?.invoices || []).filter((i) => i != null) as PInvoice[],
    'issuedAt',
    Sort.Desc,
  ) as PInvoice[];

  return (
    <div className="py-2-0">
      <p className="font-bd mb-1-0 text-2-0">{t('orders.documents.title')}</p>
      <InvoicesTable invoiceList={invoices} />
    </div>
  );
};

export default InvoicesPage;
